import React from "react";
import { Canvas, TDrawFunction } from "../../../Components/Canvas";

export type TDirection = "forwards" | "backwards" | "none";
export type TOrientation = "horizontal" | "vertical";

interface IFlowIndicatorProps {
  direction: TDirection;
  orientation: TOrientation;
}

const FlowIndicator = (props: IFlowIndicatorProps) => {
  const { direction, orientation } = props;

  const width = orientation === "horizontal" ? 40 : 4;
  const height = orientation === "horizontal" ? 4 : 40;

  const draw: TDrawFunction = (ctx, frameCount) => {
    const { width, height } = ctx.canvas.getBoundingClientRect();
    ctx.fillStyle = "rgba(255, 255, 255, 1)";
    ctx.fillRect(0, 0, width, height);

    if (direction === "none") {
      return;
    }

    const totalLength = orientation === "horizontal" ? width : height;
    const energyLength = totalLength / 2;
    const tmp = frameCount % (totalLength + 2 * energyLength);
    const tmp2 =
      direction === "forwards" ? tmp - energyLength : totalLength - tmp;

    const gradient =
      orientation === "horizontal"
        ? ctx.createLinearGradient(tmp2, 0, tmp2 + energyLength, 0)
        : ctx.createLinearGradient(0, tmp2, 0, tmp2 + energyLength);
    gradient.addColorStop(0, "rgba(255, 100, 100, 0)");
    gradient.addColorStop(0.5, "rgba(255, 100, 100, 1)");
    gradient.addColorStop(1, "rgba(255, 100, 100, 0)");
    ctx.fillStyle = gradient;

    if (orientation === "horizontal") {
      ctx.fillRect(tmp2, 0, energyLength, height);
    } else {
      ctx.fillRect(0, tmp2, width, energyLength);
    }
  };

  return <Canvas draw={draw} width={width} height={height} />;
};

export default FlowIndicator;
